export default __webpack_public_path__ + "static/media/3.4b7d6f0e.png";